import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    '@global': {
      '#kenoAnimationWidget': {
        height: '-webkit-fill-available !important'
      },
      '#kenoHotColdWidget': {
        paddingTop: '0 !important'
      },
      '#kenoHotColdWidget > div:first-child': {
        margin: '0 !important'
      }
    },
    root: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      boxShadow: 'rgba(81,116,139,0.3) 0px 0px 20px inset',
      padding: 8,
      minWidth: 400, // for testing responsiveness
      minHeight: 210, // for testing responsiveness
      height: '100%',
      width: '100%'
    },
    title: {
      marginTop: theme.spacing(),
      marginBottom: 10,
      textAlign: 'center',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center'
    },
    footer: {
      flex: 1,
      textAlign: 'center',
      alignItems: 'flex-end',
      justifyContent: 'flex-end'
    },
    errorTextContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    errorText: {
      padding: '15%',
      textAlign: 'center'
    },
    numbersRow: {
      marginBottom: theme.spacing(),
      display: 'flex',
      flex: 10,
      flexDirection: 'row',
      alignItems: 'center'
    },
    numberContainer: {
      flex: 1,
      position: 'relative',
      width: 32,
      height: 36,
      margin: 2
    },
    numberImage: {
      height: 36,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    numberText: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    lightText: {
      color: theme.palette.common.white
    },
    darkText: {
      color: '#333333'
    }
  });

export default styles;
